import React from 'react';
import clsx from 'clsx';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

import Dash from '@dashboard/components/Dash';
import Link from '@dashboard/components/Link';
import Tooltip from '@dashboard/components/Tooltip';
import { Button } from '@dashboard/components/ui/button';
import getStripeDashboardUrl from '@dashboard/lib/stripe/get-stripe-dashboard-url';

const TOOLTIP = 'Only for live payments';

/**
 * A Details row for a Stripe ID: the ID links to the Stripe dashboard with an external-link icon just
 * left of it; both grey out with a tooltip in test mode, as the old link did.
 */
export default function stripeIdRow({
  label,
  id,
  path,
  livemode,
  seller,
  isAdminLoggedInAsSeller,
  tooltip = TOOLTIP,
}) {
  if (!id) return { label, value: <Dash />, copy: null };
  const disabled = !livemode;
  const href = getStripeDashboardUrl(path, { seller, isAdminLoggedInAsSeller });
  const wrap = node => (disabled ? <Tooltip label={tooltip}>{node}</Tooltip> : node);
  return {
    label,
    copy: id,
    rail: wrap(
      <Button
        variant="ghost"
        size="icon-xs"
        aria-label="Open in Stripe"
        asChild
        className={clsx('text-gray-500 dark:text-muted-foreground', {
          'pointer-events-none opacity-50': disabled,
        })}
      >
        <Link bare to={href} blank>
          <ArrowTopRightOnSquareIcon />
        </Link>
      </Button>,
    ),
    value: wrap(
      <Link
        to={href}
        blank
        className={clsx({ 'pointer-events-none opacity-50 cursor-not-allowed': disabled })}
      >
        {id}
      </Link>,
    ),
  };
}
